import { ResizeContainer, styled } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import { FC } from "react";

export const CTAGroupWrapper = styled("div", {
  width: "100%",
  display: "flex",
  variants: {
    layout: {
      column: {
        flexDirection: "column",
        alignItems: "center",
        a: {
          marginTop: toRem(10),
        },
        "a:first-child": {
          marginTop: 0,
        },
        button: {
          marginTop: toRem(10),
        },
        "button:first-child": {
          marginTop: 0,
        },
      },
      row: {
        a: {
          marginLeft: toRem(10),
        },
        "a:first-child": {
          marginLeft: 0,
        },
        button: {
          marginLeft: toRem(10),
        },
        "button:first-child": {
          marginLeft: 0,
        },
      },
    },
  },
  defaultVariants: {
    layout: "row",
  },
});

const INADEQUATE_SPACE_BREAKPOINT = 350;

export interface CTAGroupProps {
  layout?: "row" | "column";
  className?: string;
  children?: React.ReactNode;
}

export const CTAGroup: FC<CTAGroupProps> = ({ children, layout, className }) => {
  return (
    <ResizeContainer>
      {({ width }) => {
        if (!width) {
          return null;
        }

        const hasInadequateSpace = width < INADEQUATE_SPACE_BREAKPOINT;
        return (
          <CTAGroupWrapper layout={hasInadequateSpace ? "column" : layout} className={className}>
            {children}
          </CTAGroupWrapper>
        );
      }}
    </ResizeContainer>
  );
};
